import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useAddMonitoringModalStore, useUserStore } from '@/stores';
import { NewMonitoringForm } from './NewMonitoringForm';

export function RegisterNewMonitoringPage() {
  const user = useUserStore(state => state.user);

  const {
    isOpen,
    onClose,
    content: contentShown,
    changeContent: setContentShown,
  } = useAddMonitoringModalStore();

  function renderModalHeaderTitle() {
    return 'Monitoramento';
  }

  function renderModalContent() {
    return <NewMonitoringForm key={1} onCancel={onClose} />;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={() => {
        setContentShown('buttons');
      }}
      size="xl"
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          color="brand-dark.300"
          fontSize="xl"
          fontWeight="medium"
          textAlign="center"
        >
          {renderModalHeaderTitle()}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px="12" pb="8">
          {renderModalContent()}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
